import React from 'react';
import { Box, Paper, Typography, useTheme } from '@mui/material';
import { Add } from '@mui/icons-material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { rentDetailsFormAction } from '../../../redux-slice/lease';
import { Button, GridContainer, GridItem, Tabs } from '../../../components/shared';
import { TAB_TYPES } from '../../../constants/CommonConstants';
import { routeConstants } from '../../../constants/routeConstants';
import ActiveLease from './ActiveLease';
import ArchiveLease from './ArchiveLease';
import { useSelector, useDispatch } from 'react-redux';

const Lease = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const [searchParams] = useSearchParams();
  const selectedTab = searchParams.get('selectedTab');

  const { leases } = useSelector((state) => state?.lease);

  const { pagination, isLoading } = leases;

  const tabs = [
    {
      heading: TAB_TYPES.ACTIVE,
      content: <ActiveLease />,
    },
    {
      heading: TAB_TYPES.ARCHIVE,
      content: <ArchiveLease />,
    },
  ];

  const onTabChange = (newValue) => {
    navigate(`/${routeConstants.LEASE_ROUTE}?selectedTab=${newValue}`, {
      replace: true,
    });
  };

  const handleAddNewClick = () => {
    dispatch(
      rentDetailsFormAction({
        subLocation: [],
        location: null,
        leaseName: '',
        leaseBegins: null,
        leaseEnds: null,
        inEffectFrom: null,
        inEffectTo: null,
        rentType: '',
        rentFee: '',
        rentRate: '',
        CAMFee: '',
        CAMRate: '',
        breakpointRevenue: '',
        breakpointRate: '',
        resetTerm: '',
        payFrequency: '',
        coinCost: '',
        cardCost: '',
        modalTypes: [],
        tierSummaryState: [
          { startBreakpoint: '0.01', tierThreshold: '', tierRate: '' },
          { startBreakpoint: '', tierThreshold: '', tierRate: '' },
        ],
        contractLink: '',
        notes: '',
        productTypes: [],
        address1: '',
        address2: '',
        zipCode: '',
        country: '',
        state: '',
        city: '',
        dba: '',
        boothInfo: '',
        calculationStarts: null,
        calculationEnds: null,
        breakpointNatural: true,
        breakpointValue: 0.0,
        thresholdRevenue: 0.0,
        leaseType: '',
        status: '',
        sublocationsOfLocation: [],
      }),
    );
    navigate(`/${routeConstants.ADD_LEASE_ROUTE}`);
  };

  return (
    <React.Fragment>
      <GridContainer>
        <GridItem xs={6} display="flex" alignItems="center">
          <Typography variant="h1">Leases</Typography>
        </GridItem>
        {selectedTab !== '3' && (
          <GridItem xs={6} display="flex" justifyContent="end" alignItems="center">
            <Button onClick={handleAddNewClick} variant="contained" data-testid="add-location-btn" startIcon={<Add />}>
              ADD NEW
            </Button>
          </GridItem>
        )}
      </GridContainer>
      <Typography variant="h3" style={{ color: theme.palette.secondary.main }} data-testid="lease-count">{`${
        isLoading ? '' : `${pagination?.total || 0} Leases`
      }`}</Typography>

      <Box component={Paper} mt={2}>
        <Tabs defaultTab={selectedTab === null ? '1' : selectedTab} tabsData={tabs} onTabChange={onTabChange} />
      </Box>
    </React.Fragment>
  );
};

export default Lease;
